import { Box, Grid, Image, Text } from "@chakra-ui/react"
import { FontFree_data } from '../FontFree_Data/FontFree_data.js'
import { FontFree_card } from "../FontFree_card/FontFree_card.jsx"
import { useNavigate } from "react-router-dom";
import { Login } from "../../Components/Login/Login.jsx";
import { Register } from '../../Components/Register/Register.jsx';


export const Home = () => {
    const personal = JSON.parse(localStorage.getItem('personal')) || {};
    const navigate = useNavigate()


    return (
        <Box>
            {/* nav */}
            <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} p={'10px 20px'}>
                <Box cursor={'pointer'} onClick={() => navigate('/FontFree')} display={'flex'} gap={'7px'}>
                    <Text fontSize={'30px'} fontWeight={'medium'}>|| Font</Text>
                    <Text fontSize={'30px'} fontWeight={'medium'} color={'blue.300'}>Free</Text>
                </Box>
                <Box>
                    {personal['token'] ?
                        <Box display={'flex'} gap={'5px'}>
                            <Text color={'blue.300'} fontWeight={'medium'}>Hi,</Text>
                            <Text>{personal['userName'] && personal['userName'].split(' ')[0]}</Text>
                        </Box> :
                        <Box display={'flex'} gap={'10px'}>
                            <Box cursor={'pointer'} color={'grey'} fontSize={['17px', '18px', '20px']} fontWeight={'medium'}><Login prop={'Font_Free'} /></Box>
                            <Box cursor={'pointer'} color={'blue.300'} fontSize={['17px', '18px', '20px']} fontWeight={'medium'}><Register prop={'Font_Free'} /></Box>
                        </Box>
                    }
                </Box>
            </Box>
            {/* content */}

            <Box>
                <Grid w={['95%', '90%', '85s%']} m={'1cm auto'} templateColumns={['repeat(1, 1fr)', 'repeat(2, 1fr)', 'repeat(3, 1fr)']} gap={['30px']}>
                    {FontFree_data && FontFree_data?.map((ele, index) => (
                        <Box key={index}>
                            <FontFree_card {...ele} />
                        </Box>
                    ))}
                </Grid>
            </Box>

        </Box>
    )
}